module.exports = __webpack_public_path__ + "static/img/yaoqing.a1b9921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yaoqing.png
// module id = fHn2
// module chunks = 24